import { Tag } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  SyncOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { mapStatus } from "../common/Utils";

// Status tag renderer, extracted verbatim from SafetyPenaltiesPage for the
// GPS section (SEN-436). The existing copies are intentionally untouched.
export function getStatusTag(status: string) {
  const statusText = mapStatus(status);
  let color = "green";
  let icon;
  switch (status.toLowerCase()) {
    case "applied":
    case "locked":
      color = "red";
      icon = <ExclamationCircleOutlined />;
      break;
    case "not_applied":
      color = "green";
      icon = <CheckCircleOutlined />;
      break;
    case "billed":
      color = "orange";
      icon = <FileTextOutlined />;
      break;
    case "to_review":
      color = "yellow";
      icon = <SyncOutlined spin />;
      break;
    default:
      color = "grey";
      icon = <MinusCircleOutlined />;
      break;
  }
  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
}
